export const updateProject = /* GraphQL */ `
  mutation UpdateProject($input: UpdateProjectInput!, $condition: ModelProjectConditionInput) {
    updateProject(input: $input, condition: $condition) {
      _deleted
      _lastChangedAt
      _version
      code
      company {
        _deleted
        _lastChangedAt
        _version
        createdAt
        description
        enabled
        id
        name
        owner
        updatedAt
      }
      companyID
      contractNumber
      createdAt
      description
      id
      name
      updatedAt
      enabled
      startAt
      endAt
    }
  }
`;

export default updateProject;
